import { ILookup } from "../data/Ilookup";
import { IKeyValue } from "../data/Ikey-value";

export class PositionsModel {
  jobTitle = '';
  salary = '';
  isAdvertised = '';
  applicantKnown = '';
  title: ILookup | null = null;
  titleOther = '';
  firstName = '';
  surname = '';
  dob = '';
  passportCountry: IKeyValue | null = null;
  passportNumber = '';
  maritalStatus: ILookup | null = null;
  education: ILookup | null = null;
  currentlyEmployed = '';
}